<nav
  class="side-nav-panel fixed start-0 top-[72px] z-[15] h-[calc(100vh-72px)] w-[var(--spacing-sidebar)] transition-transform duration-300"
  [class.-translate-x-full]="!sidebarOpen() && isMobile()"
  [class.translate-x-0]="sidebarOpen() || !isMobile()"
  [class.hidden]="!isMobile() && navItems.length === 0"
>
  <div class="flex h-full flex-col">
    <!-- <div class="border-b border-slate-100 px-5 py-5">
      <img
        src="assets/images/renterz-logo.svg"
        alt="Renterz"
        class="h-10 w-auto max-w-[150px] object-contain"
      />
    </div> -->

    <ul class="flex-1 space-y-2 overflow-y-auto px-3 py-4">
      @for (item of navItems; track item.id ?? item.routerLink) {
        <li>
          <button
            type="button"
            class="side-nav-item"
            [class.is-active]="isNavActive(item.routerLink)"
            (click)="routeTo(item.routerLink)"
          >
            <i class="side-nav-icon" [ngClass]="item.iconClass"></i>
            <span class="truncate">{{ item?.displayName || item?.name }}</span>
          </button>
        </li>
      }

      @if (isMobile()) {
        @if (!hasNavItem('/help')) {
        <li>
          <button
            type="button"
            class="side-nav-item"
            [class.is-active]="isNavActive('/help')"
            (click)="routeTo('/help')"
          >
            <i class="side-nav-icon sidebar-help-support"></i>
            <span class="truncate">{{ translationService.instant('header.helpSupport', 'Help & Support') }}</span>
          </button>
        </li>
        }

        <li>
          <div class="side-nav-item side-nav-item--control">
            <i class="side-nav-icon sidebar-language"></i>
            <span class="side-nav-item__label truncate">{{ translationService.instant('header.language', 'Language') }}</span>
            <div
              class="side-nav-inline-toggle"
              role="group"
              [attr.aria-label]="translationService.instant('header.language', 'Language')"
              (click)="$event.stopPropagation()"
            >
              <button
                type="button"
                class="side-nav-pill"
                [class.is-active]="currentLanguage() === 'en'"
                (click)="selectLanguage('en')"
              >
                EN
              </button>
              <button
                type="button"
                class="side-nav-pill"
                [class.is-active]="currentLanguage() === 'ar'"
                (click)="selectLanguage('ar')"
              >
                AR
              </button>
            </div>
          </div>
        </li>

        <li>
          <div class="side-nav-item side-nav-item--control">
            <i class="side-nav-icon sidebar-layout"></i>
            <span class="side-nav-item__label truncate">{{ translationService.instant('common.tableView', 'Layout') }}</span>
            <div class="side-nav-inline-toggle" role="group" (click)="$event.stopPropagation()">
              <button
                type="button"
                class="side-nav-pill"
                [class.is-active]="viewMode() === 'table'"
                (click)="setViewMode('table')"
                [title]="translationService.instant('common.tableView', 'Table View')"
              >
                {{ translationService.instant('common.table', 'Table') }}
              </button>
              <button
                type="button"
                class="side-nav-pill"
                [class.is-active]="viewMode() === 'card'"
                (click)="setViewMode('card')"
                [title]="translationService.instant('common.cardView', 'List View')"
              >
                {{ translationService.instant('common.list', 'List') }}
              </button>
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
</nav>
